import React, { useContext } from 'react'
import { UserContext } from '../../context/UserProvider'
import './admin-build-number.css'

export const buildNumber = process.env.REACT_APP_BUILD_NUMBER || '1.6'
export const buildHash = process.env.REACT_APP_BUILD_HASH || 'unknown'

export default function AdminBuildNumber() {
  const { token, userType } = useContext(UserContext)
  if (!token || userType !== 'admin') return null

  return <small className="admin-build-number" aria-label="Application build number" title={`Build commit: ${buildHash}`}>Build {buildNumber} · {buildHash.slice(0, 8)}</small>
}
